import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import { ProviderTransferCompanyType } from 'src/types/providerTransferCompany';
import { FormErrorsType, OnChangeType } from '.';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import Select from 'src/components/Select';

export interface DetailPropsType {
    onChange: OnChangeType;
    providersCodes: ConstantsCodeType[];
    editData: ProviderTransferCompanyType;
    editErrors: FormErrorsType;
    disableEdit: boolean;
    orderStatusCodes: ConstantsCodeType[];
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={6}>
                <Select
                    options={props.providersCodes}
                    value={props.editData.TARGET_PROVIDER_ESHOP_KEY}
                    error={props.editErrors.TARGET_PROVIDER_ESHOP_KEY}
                    onChange={(value, error) => props.onChange('TARGET_PROVIDER_ESHOP_KEY', value, error)}
                    name="TARGET_PROVIDER_ESHOP_KEY"
                    label={translate('providerTransferCompanyDetail.targetProviderEshopKey')}
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
        </Grid>
    );
};

export default Detail;
